import bonus1Img from "../../../assets/img/bonus-1.png";
import bonus1ImgWebp from "../../../assets/img/bonus-1.webp";
import bonus2Img from "../../../assets/img/bonus-2.png";
import bonus2ImgWebp from "../../../assets/img/bonus-2.webp";

const Gifts = () => (
    <section id="gifts">
        <div className="container-fluid gg-bg-solid-green-light">
            <div className="row justify-content-center align-content-center py-4">
                <div className="col-xxl-8 col-lg-10 col-11 py-5 px-xxl-4 px-3 gg-bg-solid-blue gg-border-radius text-white text-center">
                    <div className="row justify-content-center align-items-center">
                        <div className="text-center">
                            <h1 className="mb-0">When You Upgrade Today</h1>
                            <h1 className="mb-0">You Also Get To Improve Your Life</h1>
                            <h1>With Dr. Hart's Wisdom</h1>
                        </div>
                    </div>
                    <div className="row justify-content-center align-items-center my-3">
                        <div className="col-md-6 text-center">
                            <p className="fs-5 gg-yellow mb-0"><span className="fw-bold">Free bonuses</span> (Total Value: $88)</p>
                            <p className="fs-5"><span className="text-uppercase fw-bold">Instant download</span> of Digital Resources</p>
                        </div>
                    </div>
                    <div className="row justify-content-center align-items-center mb-5">
                        <div className="col-md-4 col-12 text-center">
                            <picture>
                                <source srcSet={bonus1ImgWebp} type="image/webp" />
                                <img className="img-fluid rounded gg-img-gift" alt="Dr. Hart" src={bonus1Img} loading="lazy" />
                            </picture>
                        </div>
                        <div className="col-md-6 col-12 mt-lg-0 mt-3 pe-md-0 text-white text-md-start text-center">
                            <h3>BONUS 1. Dr. Hart’s <span className="gg-yellow">Blood Sugar Cheat Sheet</span> (Value: $39)</h3>
                            <p>Your no-nonsense advice to real-life blood sugar control. It’s the roadmap Dr. Hart gives exclusively to his own patients. But now, it can be yours.</p>
                        </div>
                    </div>
                    <div className="row justify-content-center align-items-center mb-4">
                        <div className="col-md-4 col-12 text-center">
                            <picture>
                                <source srcSet={bonus2ImgWebp} type="image/webp" />
                                <img className="img-fluid rounded gg-img-gift" alt="Dr. Hart" src={bonus2Img} loading="lazy" />
                            </picture>
                        </div>
                        <div className="col-md-6 col-12 mt-lg-0 mt-3 pe-md-0 text-white text-md-start text-center">
                            <h3>Bonus 2. Dr. Hart’s <span className="gg-yellow">Metabolic Reset Protocol</span> (Value: $49)</h3>
                            <p>A 30-day guide to help boost your metabolism, naturally support blood sugar, and rebuild trust in your body. Without dieting, calorie counting, or carb-cutting.</p>
                        </div>
                    </div>
                    <h5>These assets make it easier than ever to stay on track and see change faster. </h5>
                </div>
            </div>
        </div>
    </section>
);

export default Gifts;